export default __webpack_public_path__ + "static/media/jurassic_hack.12469407.png";